import { Component } from '@angular/core';

@Component({
    selector: 'atlas-management-mobile-view-panel',
    templateUrl: './managment-mobile-view-panel.component.html',
    styleUrls: ['./managment-mobile-view-panel.component.less'],
    standalone: false
})
export class ManagementMobileViewPanelComponent {}
